import { apiClient } from "src/careflow/ph-core/api_client/api_client";

const careTeamBaseUrl = '/careTeam';

export const updateCareTeamMembers = async (payload: any, careTeamId: string): Promise<any> => {
  try {
    const data = await apiClient.put(`${careTeamBaseUrl}/${careTeamId}/members`, payload);
    return data;
  } catch (error) {
    return false;
  }
};

export const updateMemberPeriod = async (payload: any, careTeamId: string): Promise<any> => {
  try {
    const data = await apiClient.put(`${careTeamBaseUrl}/${careTeamId}/member`, payload);
    return data;
  } catch (error) {
    return false;
  }
};

export const createCareTeam = async (payload: any): Promise<any> => {
  try {
    const data = await apiClient.post(careTeamBaseUrl, payload);
    return data;
  } catch (error) {
    return false;
  }
};

export const updateCareTeam = async (payload: any, careTeamId: string): Promise<any> => {
  try {
    const data = await apiClient.put(`${careTeamBaseUrl}/${careTeamId}`, payload);
    return data;
  } catch (error) {
    return false;
  }
};